import React, { FC, useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  Wrapper,
} from './AdditionalListContentUI';
import { Checkbox } from '../general/forms/Checkbox';
import { ProductCategoryWithProductAndPermissions, UserProductPermissionProps } from '../forms/UserForm';

export interface AdditionalUserProductPermissionsSelectAllListContentProps {
  permissions: ProductCategoryWithProductAndPermissions[];
  toggleAllLeads: (checked: boolean) => void;
  toggleAllContracts: (checked: boolean) => void;
  toggleAllSampleContracts: (checked: boolean) => void;
}

const ContentRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  padding: 1rem 0;
`;

const CheckboxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const CheckboxLabel = styled.div`
  margin-bottom: 1rem;
`;

export const AdditionalUserProductPermissionsSelectAllListContent: FC<AdditionalUserProductPermissionsSelectAllListContentProps> = (props) => {
  const { permissions, toggleAllContracts, toggleAllLeads, toggleAllSampleContracts } = props;

  const [leadsPermissionActive, setLeadsPermissionActive] = useState<boolean>(false);
  const [sampleContractPermission, setSampleContractPermission] = useState<boolean>(false);
  const [contractPermission, setContractPermission] = useState<boolean>(false);

  useEffect(() => {
    if (permissions) {

      const leadPermissions: boolean[] = [];
      permissions.map((category) => {
        category.products.map((product) => {
          leadPermissions.push(product.permissions.hasLeadPermission);
        });
      });

      setLeadsPermissionActive(Boolean(!leadPermissions.includes(false)));

      const sampleContractPermissions: boolean[] = [];
      permissions.map((category) => {
        category.products.map((product) => {
          sampleContractPermissions.push(product.permissions.hasSampleContractPermission);
        });
      });

      setSampleContractPermission(Boolean(!sampleContractPermissions.includes(false)));

      const contractPermissions: boolean[] = [];
      permissions.map((category) => {
        category.products.map((product) => {
          contractPermissions.push(product.permissions.hasContractPermission);
        });
      });

      setContractPermission(Boolean(!contractPermissions.includes(false)));
    }
  }, [permissions]);

  return (
    <Wrapper>
      <ContentRow>
        <CheckboxWrapper>
          <CheckboxLabel>Lead</CheckboxLabel>
          <Checkbox
            checked={leadsPermissionActive}
            id={'select-all-leads'}
            onChange={(checked) => {
              toggleAllLeads(checked);
              setLeadsPermissionActive(checked);
            }}/>
        </CheckboxWrapper>
        <CheckboxWrapper>
          <CheckboxLabel>Mustervertrag</CheckboxLabel>
          <Checkbox
            checked={sampleContractPermission}
            id={'select-all-sample-contracts'}
            onChange={(checked) => {
              toggleAllSampleContracts(checked);
             setSampleContractPermission(checked);
            }}/>
        </CheckboxWrapper>
        <CheckboxWrapper>
          <CheckboxLabel>Vertrag</CheckboxLabel>
          <Checkbox
            checked={contractPermission}
            id={'select-all-contracts'}
            onChange={(checked) => {
              toggleAllContracts(checked);
              setContractPermission(checked);
            }}/>
        </CheckboxWrapper>
      </ContentRow>
    </Wrapper>
  );
};
